import { NgModule } from '@angular/core';
import { RollupContentComponent } from './rollup-content.component';

@NgModule({
    declarations: [RollupContentComponent],
    exports: [RollupContentComponent],
})
export class FiRollupContentModule {}
